import React, { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type TitleProps = {
  as?: "h1" | "h2" | "h3" | "h4";
  size?: "sm" | "base" | "lg" | "xl";
  children: string | ReactNode;
  className?: string;
};

const Title = ({ size = "base", children, className = "", as }: TitleProps) => {
  const fontSize = {
    sm: "text-2xl",
    base: "text-3xl md:text-4xl lg:text-5xl",
    lg: "text-4xl md:text-5xl lg:text-6xl",
    xl: "text-5xl md:text-6xl lg:text-7xl",
  };

  // ✅ IMPORTANT: Never auto-generate H1
  // Only render H1 when explicitly asked via as="h1"
  const Component =
    as ??
    (size === "sm"
      ? "h4"
      : size === "base"
        ? "h3"
        : "h2"); // lg + xl both become h2

  return (
    <Component
      className={twMerge(
        "justify-center text-center font-serif font-thin text-white",
        fontSize[size],
        className
      )}
    >
      {children}
    </Component>
  );
};

export default Title;
